import _ from 'lodash'
import useAnalytics from '~/utils/analytics'
import { useTheme } from '~/contexts/ThemeContext';
import { isStag } from '~/utils/helpers'

const useFilterHook = () => {
  const { locate } = useTheme()
  const { ga_plp_filter, ga_plp_sort } = useAnalytics()

  const upd_prods = ( prods, colldata) => {
    const { products, filters, currSort, plpInv, gender } = colldata

    const is_filters = filters.length > 0
    const is_stores = locate?.currStores.length > 0
    const is_subnavfilt = colldata.subnav && (filters.length === 1 && filters[0].type === 'groupstyle')

    let shown_products = prods

    if (is_filters) {
      shown_products = products.filter(x => x !== null && x.pl_pima && x.pl_pima !== 99998)
      if ( filters.length > 0 ) shown_products = do_filtering(shown_products, colldata)
    }
    if (is_stores) shown_products = filter_stores(shown_products, plpInv, gender)
    if (!!currSort) shown_products = sort_prods(shown_products, currSort)

    if (is_subnavfilt) {
      const pls = [...new Set(shown_products.map(x => x.pl_handle))]
      shown_products = _.sortBy(shown_products, x => _.indexOf(pls, x.pl_handle))

      pls.forEach( (pl) => {
        const first_prod = shown_products.find(x => x.group !== 'div' && x.pl_handle === pl)
        const index = _.findIndex(shown_products, x => x.group !== 'div' && x.pl_handle === pl)
        shown_products.splice(index, 0, {group: 'div', name: `${first_prod.pl_name}`})
      })
    }

    return shown_products
  }

  const do_filtering = ( prods, colldata ) => {
    const { filters } = colldata
    const multi_types = ['type','fabric','style']

    let show_prods = filters.length ? prods.filter(prod => prod.hasOwnProperty('filters')) : prods

    const multis = filters.filter(x => multi_types.includes(x.type) )
    const drilldowns = filters.filter(x => !multi_types.includes(x.type) )

    let ids_found = []
    let any_found = false

    multis.forEach(obj => {
      let prods_found = show_prods
      prods_found = prods_found.map(prod => {
        const typestr = obj.type === 'style' ? 'groupstyle' : obj.type
        let p_filts = prod.filters[typestr] || []
        p_filts = p_filts.filter( x => !!x).map( x => x.toLowerCase() )
        return p_filts.includes(obj.name.toLowerCase()) ? prod.mid : false 
      })
      prods_found = prods_found.filter(x => !!x )
      ids_found = ids_found.concat( prods_found )
    })

    if ( ids_found.length ) any_found = true

    drilldowns.forEach(obj => {
      let drill_ids = prods.map(prod => {
        let p_filts = prod.filters[obj.type] || []
        p_filts = p_filts.filter( x => !!x).map( x => x.toLowerCase() )
        return p_filts.includes(obj.name.toLowerCase()) ? prod.mid : false 
      })
      drill_ids = drill_ids.filter(x => !!x )

      ids_found = !ids_found.length && any_found ? [] : ids_found.length ? _.intersectionWith(ids_found, drill_ids, _.isEqual) : drill_ids
      if ( drill_ids.length ) any_found = true
    })

    let results = show_prods.filter(x => ids_found.includes(x.mid))
    if (sessionStorage.getItem('lastfilt')) ga_plp_filter(filters, results.length)

    return results
  }

  const filter_stores = (results, plpInv=false, coll_gend, storeGendConflct) => {
    if (results?.length < 1) return []
    if (locate?.currStores?.length < 1 && !locate?.shipIntl) return results
    if (storeGendConflct && coll_gend && coll_gend !== 'u') return results

    let new_results = results
    const wrapped = Array.isArray(results[0])
    if (wrapped) new_results = new_results.flat()
    const grouped = new_results.find(x => !!x.products)
    if (grouped) new_results = new_results.flatMap(x => x.products)
    
    new_results = stores_prods(new_results, plpInv)
    return new_results
  }

  const stores_prods = (products, plpInv) => {
    // const prod_inv = (obj.type === 'locations' && plpInv.length) ? plpInv.find(x => deShopId(x.id) === prod.shop_id) : false
    // const filts_src = (obj.type === 'locations' && prod_inv) ? prod_inv.filters : prod.filters

    // const wh_short = isStag() ? 'WH' : 'DW'
    const wh_shorts = isStag() ? ['WH'] : ['DW','BL - Ecommerce']
    const stores_arr = (locate?.shipIntl && locate?.currStores.length < 1) ? wh_shorts : locate?.currStores || []
    const filterd_prods = products.filter(product => {
      if (!product?.pl_pima) return false
      if (product?.pl_pima === 99998) return true
      const inv = product.filters?.locations
      if (!inv) return false
      return inv.some(x => stores_arr.includes(x))
    })
    return filterd_prods
  }


  const sort_prods = (products, currSort) => {
    let shown_products = products.flat().filter(x => x.pl_pima !== 99998)
    let count = 0
    const is_grouped = shown_products.find(x => x.hasOwnProperty('products'))

    const do_sort = (prods) => {
      let sorted = prods
      if ( currSort === 'asc' || currSort === 'desc' ) {
        sorted = _.sortBy(sorted, x => parseInt(x.first_product_price) );
      }
      if ( currSort === 'desc' ) {
        sorted.reverse();
      }
      if ( currSort === 'rec' ) {
        sorted = _.sortBy(sorted, x => x.pub ? parseInt(x.pub) : 0 ).reverse()
      }
      if ( currSort === 'best' ) {
        sorted = _.sortBy(sorted, x => x.callouts ? x.callouts.find( c => c.name === 'Best Seller') || '\uffff' : '\uffff' ); 
      }
      if ( currSort === 'perc' ) {
        sorted = _.sortBy(sorted, x => x.percent_off ? parseFloat(x.percent_off) : 0 ).reverse();
      }
      return sorted
    }

    if (is_grouped) {
      // shown_products = shown_products.map(x => {
      //   const sorted = do_sort(x.products)
      //   count += sorted.length
      //   return {
      //     mid: x.mid,
      //     data: x.data,
      //     products: sorted
      //   }
      // })
      // shown_products = shown_products.sort((a, b) => {
      //   return a.products[0].first_product_price -  b.products[0].first_product_price
      // })
      // if ( currSort === 'desc' ) shown_products = shown_products.reverse()
      shown_products = do_sort(shown_products.flatMap(x => x.products))
      count = shown_products.length
    } else {
      shown_products = do_sort(shown_products)
      count = shown_products.length
    }
    
    ga_plp_sort(currSort, count)

    return shown_products
  }
  

  const upd_filters = ( adding, filters, currGrpName ) => {
    const applied = filters.find( x => x.type === adding.type && x.name === adding.name)

    let new_filters 

    if (applied) {
      new_filters = filters.filter( x => !(x.name === adding.name && x.type === adding.type))
    } else {
      new_filters = [...filters, adding]

      sessionStorage.setItem('lastfilt', `${adding.type}: ${adding.name}`)
    }

    upd_params(new_filters, currGrpName)
    
    return new_filters
  }


  const upd_params = ( new_filters, currGrpName ) => {
    const params = new URLSearchParams('')

    new_filters.forEach(x => {
      let names = params.get(x.type) ? params.get(x.type).split(',') : []
      params.set(x.type, names.push(x.name.replaceAll("'",'')) && _.uniq(names)) 
    })

    const cleanname = currGrpName ? currGrpName.replaceAll("'",'') : currGrpName
    if (cleanname) params.set('gt', cleanname)

    const new_url = params.size ? `?${params.toString()}` : window.location.pathname
    window.history.replaceState(null, null, new_url)

    const breadpath = (new_filters.length || cleanname) ? `${window.location.pathname}?${params.toString()}` : window.location.pathname
    sessionStorage.setItem('fbread',breadpath)
  }
  

  const parse_filters = ( prods, filter_order=[] ) => {
    if ( !prods ) return false

    const filter_obj = {}

    let sizes = prods.map(x => x).filter(x => !!x && x.pl_pima !== 99998 && x.pl_pima !== 99999).map(x => x.filters)
    sizes = [...new Set( sizes.filter(x => !!x && x.hasOwnProperty('size')).map(x => x.size).flat() )]
    if (sizes.length > 0) filter_obj['size'] = sizes

    prods.filter(x => x !== null && x.pl_pima !== 99998).forEach( product => {
      if (product === null || !product.hasOwnProperty('filters')) return

      const keys = Object.keys(product.filters).filter( x => {
        const bads = ['groupfabric','groupmarketing','gift','inseam','size','locations']
        return x === 'gender' || (!bads.includes(x) && filter_order.includes(x))
      })

      keys.forEach( k => {
        const name = k === 'groupstyle' ? 'style' : k
        filter_obj[name] ||= [] 
        const vals = product.filters[k]
        const vals_arr = vals ? vals.map(x => x && x.toLowerCase()) : []
        filter_obj[name] = [...new Set( filter_obj[name].concat(vals_arr) )]
      })
    })

    return filter_obj
  }

  // const all_coll_group = (prods, group_types, currGrpName=false) => {
  //   const have_filter = prods.filter(x => !!x && x.hasOwnProperty('filters') && !!x.filters && x.filters.hasOwnProperty('type'))
    
  //   if ( currGrpName ) {
  //     return have_filter.filter(x => x.filters.type.includes(currGrpName))
  //   }

  //   let new_groups = []
  //   group_types.forEach(type_name => {
  //     let type_prods = have_filter.filter(x => x.filters.type.includes(type_name))
  //     const pls = [...new Set(type_prods.map(x => x.pl_name).flat())]
  //     type_prods.sort((a, b) => pls.indexOf(a.pl_name) - pls.indexOf(b.pl_name) )

  //     new_groups.push({group: 'group', type: type_name, description: null, callouts: []})
  //     new_groups = new_groups.concat(type_prods)
  //   })

  //   return new_groups
  // }


  // const pl_grouping = (prods) => {
  //   let types = [...new Set(prods.map(x => x.pl_name).flat())]
  //   let new_groups = []
  //   types.forEach(pl_name => {
  //     const plprods = prods.filter(x => x.pl_name === pl_name)
  //     new_groups.push({group: 'group', type: pl_name, description: plprods[0].short_description, callouts: []})
  //     new_groups = new_groups.concat(plprods)
  //   })

  //   return new_groups
  // }
  


  return { upd_filters, upd_prods, parse_filters, upd_params, filter_stores };
};

export default useFilterHook;